// extracted by mini-css-extract-plugin
module.exports = {"redeemModal":"redeem_redeemModal__X7pif","btn":"redeem_btn__4BYkA"};